<div class="topbar" *ngIf="!isFilter">
  <h4 class="topbar-title">
    SIP trunks<span class="icon-help-1 ml-15" [tooltip]="'Select from the list of sip trunks below'" tooltipPlacement="top"></span>
  </h4>
  <div class="right-icons"></div>
</div>

<div *ngIf="!isFilter" class="topbar-search">
  <input type="text" class="form-control select-input" placeholder="Select trunks" [value]="searchQuery" [formControl]="searchControl" />
  <span class="icon-search search-icon"></span>
</div>

<div *ngIf="isFilter" class="filter-input-section d-flex justify-space-between align-items-center">
  <input type="text" class="form-control select-input" placeholder="Select trunks" [value]="searchQuery" [formControl]="searchControl" />
  <span class="icon-search position-absolute"></span>
  <span tooltip="Clear all selected" class="far fa-trash-alt" (click)="onDeleteFilterClick()"></span>
</div>

<div class="supply-wrapper" [ngClass]="{ restrict: isFilter }" #elWrapper>
  <div class="tab-content" id="myTabContent" [ngClass]="{ 'cn-wrapper': isFilter }">
    <div *ngIf="loading" class="d-flex justify-content-center align-items-center py-30">
      <div class="loader"></div>
    </div>
    <div *ngIf="!loading" class="tab-pane mix-select-box fade show active" id="all1" role="tabpanel" aria-labelledby="all1-tab">
      <cdk-virtual-scroll-viewport
        itemSize="30"
        [style.height.px]="30 * rowsVisible"
        (scrolledIndexChange)="onScrolledIndexChange($event)"
        #scrollViewportAll>
        <div class="list-row" *cdkVirtualFor="let c of models" (click)="toggle(c); $event.stopPropagation()">
          <div class="input-check">
            <input
              class="form-check-input"
              type="checkbox"
              [disabled]="isSipTrunkDisabled(c)"
              [ngModel]="c.selected"
              [ngModelOptions]="{ standalone: true }" />
          </div>
          <div class="text" [ngClass]="{ cp: isSipTrunkActive(c), 'text-neutral-n6': !isSipTrunkActive(c) }">
            <span [tooltip]="getSipTrunkTooltipContent(c)" tooltipDelay="500" tooltipPlacement="top">
              {{ c.name }}
            </span>
            <span class="category" [ngClass]="getSipTrunkCategoryClass(c)"></span>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>
</div>
